export default __webpack_public_path__ + "static/media/top-part-pattern.0428ac96.png";